<template>
  <div>
    <ag-table
      :form-table-check="true"
      :grid-options="gridOptions"
      :row-data="rowData"
      :rtl="false"
      @emitDeleteMultipleRecords="deleteForm($event, null , true)"
      @emitShowDetails="showDetails(0)"
    >
      <template v-slot:dropdown>
        <checked-card
          :btn-name="btnName"
          :grid-options="gridOptions"
          :status="status"
          @fetchAllForms="fetchAllForms(($event))"
          :show="true"
        />
      </template>


      <template v-slot:checkButton>
        <checked-card
          :btn-name="btnName"
          :grid-options="gridOptions"
          :status="status"
          @fetchAllForms="fetchAllForms(($event))"
          :show="false"
        />
      </template>
    </ag-table>


    <vs-popup
      title="تفاصيل الإستمارة"
      :active.sync="popupActiveDetails"
      :button-close-hidden="true"
    >
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 px-4">
        <div>
          <label>الاسم :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.fullname"
          />
        </div>

        <div>
          <label>العنوان :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.address"
          />
        </div>

        <div>
          <label>الهاتف :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.phone"
          />
        </div>

        <div>
          <label>الهاتف المحمول :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.mobile"
          />
        </div>

        <div>
          <label>القيد :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.kayd"
          />
        </div>

        <div>
          <label>مكان الولادة :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.birthplace"
          />
        </div>

        <div>
          <label>تاريخ الولادة :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.birthday"
          />
        </div>

        <div>
          <label>الجنسية :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.nationality"
          />
        </div>
      </div>

      <div class="mt-8 px-4">
        <label class="sectionName">المؤهلات والخبرات :</label>

        <div
          :key="item.id"
          v-for="item in form.qualifications_and_skills"
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 mt-6"
        >
          <div>
            <label>الجهة :</label>
            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.awarding"
            />
          </div>

          <div>
            <label>الشهادة العلمية :</label>
            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.scientific_certificate"
            />
          </div>

          <div>
            <label>التخصص :</label>
            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.specialization"
            />
          </div>
        </div>
      </div>

      <div class="mt-8 px-4">
        <label class="sectionName">مهارات التدريس :</label>

        <div
          class="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-6 mt-6"
          :class="[index == form.teaching_skills.length-1 ? '':'borderBottom pb-8']"
          :key="index"
          v-for="(item,index) in form.teaching_skills"
        >
          <div>
            <label>المادة :</label>


            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.name"
            />
          </div>

          <div>
            <label>المرحلة :</label>


            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.class"
            />
          </div>

          <div>
            <label>المكان :</label>


            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.place"
            />
          </div>

          <div>
            <label>الرغبة :</label>


            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.desired"
            />
          </div>
        </div>
      </div>


      <div class="flex justify-end items-center mt-8 px-4">
        <vs-button
          @click="popupActiveDetails=false"
          type="filled"
          ycolor="success"
        >
          حسناً
        </vs-button>
      </div>


      <!-- <div class="mt-6 px-4">
                        <label >ملاحظات الزبون :</label>
                        <vs-textarea placeholder="الملاحظات" v-model="order.user_note" disabled  class="w-full mt-3" color="#5E445A"/>
                </div> -->
    </vs-popup>


    <vs-popup
      title="تفاصيل الإستمارة"
      :active.sync="popupActive"
      :button-close-hidden="true"
    >
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 px-4">
        <div>
          <label>الاسم :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.fullname"
          />
        </div>

        <div>
          <label>العنوان :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.address"
          />
        </div>

        <div>
          <label>الهاتف :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.phone"
          />
        </div>

        <div>
          <label>الهاتف المحمول :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.mobile"
          />
        </div>

        <div>
          <label>القيد :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.kayd"
          />
        </div>

        <div>
          <label>مكان الولادة :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.birthplace"
          />
        </div>

        <div>
          <label>تاريخ الولادة :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.birthday"
          />
        </div>

        <div>
          <label>الجنسية :</label>
          <vs-input
            placeholder=""
            name="title"
            disabled
            color="#5E445A"
            class="w-full mt-3"
            v-model="form.nationality"
          />
        </div>
      </div>

      <div class="mt-8 px-4">
        <label class="sectionName">المؤهلات والخبرات :</label>

        <div
          :key="item.id"
          v-for="item in form.qualifications_and_skills"
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 mt-6"
        >
          <div>
            <label>الجهة :</label>
            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.awarding"
            />
          </div>

          <div>
            <label>الشهادة العلمية :</label>
            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.scientific_certificate"
            />
          </div>

          <div>
            <label>التخصص :</label>
            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.specialization"
            />
          </div>
        </div>
      </div>

      <div class="mt-8 px-4">
        <label class="sectionName">مهارات التدريس :</label>

        <div
          class="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-6 mt-6"
          :class="[index == form.teaching_skills.length-1 ? '':'borderBottom pb-8']"
          :key="index"
          v-for="(item,index) in form.teaching_skills"
        >
          <div>
            <label>المادة :</label>


            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.name"
            />
          </div>

          <div>
            <label>المرحلة :</label>


            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.class"
            />
          </div>

          <div>
            <label>المكان :</label>


            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.place"
            />
          </div>

          <div>
            <label>الرغبة :</label>


            <vs-input
              placeholder=""
              name="title"
              disabled
              color="#5E445A"
              class="w-full mt-3"
              v-model="item.desired"
            />
          </div>
        </div>
      </div>


      <div class="flex justify-center items-center mt-8 px-4 w-full">
        <vs-button
          class="mx-4"
          @click="showDetails(record.index,'previous')"
          type="filled"
          v-show="record.isPrevious"
          ycolor="success"
        >
          السابق
        </vs-button>

        <vs-button
          class="mx-4"
          @click="showDetails(record.index,'next')"
          type="filled"
          v-show="record.isNext"
          ycolor="success"
        >
          التالي
        </vs-button>
      </div>


      <!-- <div class="mt-6 px-4">
                        <label >ملاحظات الزبون :</label>
                        <vs-textarea placeholder="الملاحظات" v-model="order.user_note" disabled  class="w-full mt-3" color="#5E445A"/>
                </div> -->
    </vs-popup>
  </div>
</template>
<script>
import AgTable from '../../../shared/shared-components/ag-grid/AgTable.vue';
import AgTableBtnCell from '../../../shared/shared-components/ag-grid/AgTableBtnCell.vue';
import {RepositoryFactory} from "../../website-repositories/websiteRepositoryFactory";
import utilities from "../../../shared/utilities";
import checkedCard from "../../website-components/checkedFormsCard";
import AgSwitch from "@/app/shared/shared-components/ag-grid/AgTableSwitchCell";

const formsRepo = RepositoryFactory.get('forms');

export default {
  name: "TeachingForm",
  components: {
    AgTable,
    checkedCard
  },
  data() {
    return {
      gridOptions: null,
      gridApi: null,
      rowData: [],
      popupActiveDetails: false,
      popupActive: false,
      record: Object,
      form: Object,
      btnName: '',
      status: ''
    };
  },

  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: 'المعرف',
          field: 'id',
          filter: 'agTextColumnFilter',
          headerCheckboxSelection: true,
          checkboxSelection: true,
        },
        {
          headerName: 'الاسم',
          field: 'fullname',
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'تاريح الولادة',
          field: 'birthday',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'مكان الولادة',
          field: 'birthplace',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'الجنسية',
          field: 'nationality',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'القيد',
          field: 'kayd',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'الهاتف',
          field: 'phone',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'الهاتف المحمول',
          field: 'mobile',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'العنوان',
          field: 'address',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'المؤهلات والخبرات',
          field: 'qualifications_and_skills',
          filter: 'agTextColumnFilter',
          valueGetter: qualificationsAndSkillsGetter,
        },
        {
          headerName: 'المهارات التدريسية',
          field: 'teaching_skills',
          filter: 'agTextColumnFilter',
          valueGetter: teachingSkillsGetter,
        },
        {
          headerName: 'تاريخ الإنشاء',
          field: 'created_at',
          valueFormatter: self.dateFormatter,
          filter: 'agTextColumnFilter',
          sortable: false,
          width: 250
        },
        {
          headerName: 'تغيير حالة المقابلة',
          field: 'checked',
          valueGetter:
            function getObject(params) {
              return params;
            },
          filter: false,
          cellRendererFramework: AgSwitch,
          cellRendererParams: {
            switchAction: function (valueGetter) {
              self.checkedForm(valueGetter.id);
            }
          },
        },
        {
          headerName: 'الإجراءات',
          field: 'id',
          cellRendererFramework: AgTableBtnCell,
          cellRendererParams: {
            viewRecordDetails: function (record) {
              self.viewRecordDetails(record);
            },
            deleteRecord: function (id, rowIndex) {
              self.deleteForm(id, rowIndex);
            },
            actions: ['view', 'delete']
          },
        },
      ];
    },
    deleteForm(ids, index, isMultiple = false) {

      this.isLoading = true;
      if (isMultiple)
        ids = ids.join(',');
      formsRepo.deleteForm(ids).then((response) => {

        this.isLoading = false;
        if (response.code === 200) {
          if (isMultiple) {
            this.fetchAllForms();
          } else {
            this.rowData.splice(index, 1);
            this.rowData = [...this.rowData];
          }
        }
        this.isLoading = false;
      });
    },

    viewRecordDetails(record) {
      this.popupActiveDetails = true;
      this.form = record;
    },
    showDetails(index, action) {
      this.popupActive = true;
      this.record = utilities.fetchRecordIndex(this.rowData.length, index, action);
      this.form = this.rowData[this.record.index];
    },
    fetchAllForms(isChecked = false) {
      let formType = 'Teaching';
      this.btnName = `${isChecked ? 'لم تتم المقابلة' : 'تمت المقابلة'}`;
      this.status = isChecked;
      formsRepo.fetchAllFormsByType(formType, isChecked).then((data) => {
        this.rowData = data;
      });
    },
    checkedForm(ids, isMultiple = false) {
      formsRepo.checkedForm(ids, this.status, isMultiple, false).then((response) => {
        if (response.code === 200) {
          if (this.status)
            this.fetchAllForms(true);
          else
            this.fetchAllForms();
        }
      });
    },
    dateFormatter(params) {
      return utilities.dateFormatter(params.data.created_at);
    }
  },

  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
    this.fetchAllForms();
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
window.teachingSkillsGetter = function (params) {
  if (params.data.teaching_skills) {
    return params.data.teaching_skills.map(value => {
      let skill = 'اسم المادة: ' + value.name;
      skill += ' ,الصف: ' + value.class;
      skill += ', المكان: ' + value.place;
      skill += `  , مرغوبة: ${value.desired === true ? 'نعم' : 'لا'}`;
      return skill;
    }).join(' / ');
  }
};

</script>

<style scoped>
.borderBottom {
  border-bottom: 0.5px solid #5E445A;
}
</style>
